import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Roster } from '../../models/roster';
import { Campaign } from '../../models/campaign';
import { DialogComponent } from '../dialog/dialog.component';
import { CampaignService } from '../../services/campaign.service';
import { RosterService } from '../../services/roster.service';
import { UserService } from '../../services/user.service';
import { User, UserRole } from '../../models/user';

@Component({
  selector: 'app-add-new-campaign-dialog',
  imports: [CommonModule, FormsModule, DialogComponent],
  templateUrl: './add-new-campaign-dialog.component.html',
  styleUrl: './add-new-campaign-dialog.component.css'
})
export class AddNewCampaignDialogComponent implements OnInit {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() campaignCreated = new EventEmitter<Campaign>();

  rosters: Roster[] = [];
  agentUsers: User[] = [];
  sourceUsers: User[] = [];
  castingUsers: User[] = [];
  selectedRosterId: string = '';
  selectedSource: string = 'Inbound';
  rate: number = 0;

  constructor(
    private campaignService: CampaignService,
    private rosterService: RosterService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService.getUsers().subscribe(users => {
      this.agentUsers = users.filter(u => u.role === UserRole.Agent || u.role === UserRole.Scouting || u.role === UserRole.Casting);
      this.sourceUsers = users.filter(u => u.role === UserRole.Agent || u.role === UserRole.Scouting || u.role === UserRole.Casting || u.role === UserRole.Admin);
      this.castingUsers = users.filter(u => u.role === UserRole.Casting);
    });

    // Load rosters when dialog is initialized
    this.rosterService.getRosters().subscribe({
      next: (rosters) => {
        this.rosters = rosters;
        // Initialize selectedRosterId to first roster if available
        if (this.rosters.length > 0 && !this.selectedRosterId) {
          this.selectedRosterId = this.rosters[0].id;
        }
      },
      error: (err) => {
        console.error('Error loading rosters:', err);
      }
    });
  }

  onCreateCampaign() {
    if (this.selectedRosterId) {
      this.campaignService.addNewCampaign(this.selectedRosterId, this.selectedSource, this.rate).subscribe({
        next: (campaign) => {
          // Populate creator name and tiktok handle from roster
          if (campaign.creatorId) {
            const matchingRoster = this.rosters.find(roster => roster.id === campaign.creatorId);
            if (matchingRoster) {
              campaign.creatorName = matchingRoster.name;
              campaign.tiktokHandle = matchingRoster.tiktokHandle;
            }
          }
          this.campaignCreated.emit(campaign);
          this.closeDialog();
        },
        error: (err) => {
          console.error('Error creating campaign:', err);
        }
      });
    }
  }

  onCancel() {
    this.closeDialog();
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.selectedRosterId = '';
    this.selectedSource = 'Inbound';
    this.rate = 0;
  }

  get sortedRosters(): Roster[] {
    return [...this.rosters].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  getCreatorDisplayText(roster: Roster): string {
    return `${roster.name} (${roster.tiktokHandle})`;
  }
}
